const vehicleDriverAttributes = `
  id
  name
  phoneNumbers
`;

const vehicleModelAttributes = `
  brand
  name
  year
  version
  isSuggestion
`;

const fuelAttributes = `
  type
  price
  consumption
`;

const vehicleGroupAttributes = `
  id
  name
`;

export const vehicleAttributes = `
  id
  device {
    id
    type
    cobliId
  }
  driver {
    ${vehicleDriverAttributes}
  }
  model {
    ${vehicleModelAttributes}
  }
  fleetId
  tagId
  licensePlate
  fuel {
    ${fuelAttributes}
  }
  size
  groups {
    ${vehicleGroupAttributes}
  }
  speedLimitInKmh
`;

export default vehicleAttributes;
